export default "__VITE_ASSET__0addyRW$__"